'use strict';
import 'jquery-mousewheel';
import 'jquery-touchswipe';
import 'jquery.scrollto';

var _this;
class anchorTool {

	constructor(anchorComponent) {

		_this = this;
		this.container = anchorComponent;
		this.active = false;

		/**
		 * Attach Mouse Wheel inidicator
		 */
		this.totalMove = 0;
		this.wheeldelta = {
			y: 0,
		};
		this.wheeling;

		//_this.attachScrollDetectMouse();
		//_this.attachSwipeDetect();
		_this.attachWindowScroll();
		_this.attachClickAnchorTool();


		// // TOOL MODULES
		// $( '#tool-modules-mobile' ).click(function() {
		// 	$( '#modules-nav ul' ).slideToggle();
		// 	$( this ).toggleClass('open');
		// });
		//
		// // TOOL BENEFITS
		// $( '#tool-benefits-mobile' ).click(function() {
		// 	$( '#benefits-nav ul' ).slideToggle();
		// 	$( this ).toggleClass('open');
		// });

	}

	attachWindowScroll(){

		let arrElemAnchorTool = _this.container.find('ul li a');

		//console.log(arrElemAnchorTool[0]);

		$(window).scroll(function () {

			//console.log('scroll');
			let scrollToTop = $(window).scrollTop();
			//console.log('SCROLL TO TOP',scrollToTop);

			if(scrollToTop > 200 && _this.container.length > 0 && !_this.active){
				//console.log('sposto');
				//let heightHeader = $('header.site-header').height();
				//gsap.to(_this.container, 0.5, {top: heightHeader});
				_this.active = true;


			}else if(scrollToTop < 200){
				//gsap.to(_this.container, 0.5, {top: '-200px'});
				_this.active = false;
				_this.container.find('li.active').removeClass('active');
			}

			for(let i = 0; i < arrElemAnchorTool.length; i++){

				let anchorToolItem = $(arrElemAnchorTool[i]);
				let idElem = anchorToolItem.attr('data-id-anchor');
				//console.log(idElem);
				let elemBox = $('#tgt-'+idElem);
				
				
				//let offsetTopElemBoxAnchor =  elemBox.offset().top;
				//console.log('offsetTopElemBoxAnchor' , idElem, offsetTopElemBoxAnchor);
				let positionTopElemBoxAnchor =  elemBox.position().top;

				//console.log('diff ' , idElem,positionTopElemBoxAnchor - scrollToTop );

				let diffBoxPosScroll = positionTopElemBoxAnchor - scrollToTop;
				if(diffBoxPosScroll <= 250 && diffBoxPosScroll > 0){
					_this.container.find('li.active').removeClass('active');
					anchorToolItem.parents('li').addClass('active');
					// let iconIdToScroll = $( 'a[data-id-anchor=\''+idElem+'\'] img').attr('src');
					// let labelIdToScroll = $( 'a[data-id-anchor=\''+idElem+'\']' ).attr('data-label');
					//$('.tool-anchor-indicator-mobile').html(labelIdToScroll.replace('<br>',' '));

					//$('.tool-anchor-indicator-mobile').html('<img src="'+iconIdToScroll+'">' + labelIdToScroll.replace('<br>',' '));
				}
				else if((scrollToTop + 250) > (positionTopElemBoxAnchor + elemBox.height()) ){
					anchorToolItem.parents('li').removeClass('active');
					_this.container.find('li.active').removeClass('active');
					//let labelIdToScroll = $( 'a[data-id-anchor=\''+idElem+'\']' ).attr('data-label');
					//$('.tool-anchor-indicator-mobile').html(labelIdToScroll.replace('<br>',' '));
				}
				//console.log(positionTopElemBoxAnchor , elemBox.height(), positionTopElemBoxAnchor + elemBox.height(), scrollToTop)
			}



		});

		$(window).resize(function(){

			_this.active = false;

		});

	}

	attachClickAnchorTool(){

		_this.container.find('a').click(function(event){

			event.preventDefault();
			let idAnchor = $(this).attr('data-id-anchor');
			//window.location.hash=idAnchor;
			window.history.pushState({}, '', window.location.origin+window.location.pathname+'#'+idAnchor);

			_this.scrollToBox(idAnchor);

			if($(window).width() < 850 && $('.tool-ancore-avanzato').length > 0) {

				$('.tool-ancore-avanzato ul').fadeOut();

				//$(this).parents('.anchorTool').find('.tool-anchor-indicator-mobile').toggleClass('open');
			}

			//let offsetToScroll = $('#'+idAnchor).offset().top - $('header.site-header').height() - _this.container.height();
			//$('body').scrollTo(offsetToScroll,500);
		});

	} 

	scrollToBox(idToScroll){
		$( 'a[data-id-anchor!=\'\']' ).parents('li').removeClass('active');
		$( 'a[data-id-anchor=\''+idToScroll+'\']' ).parents('li').addClass('active');

		// let iconIdToScroll = $( 'a[data-id-anchor=\''+idToScroll+'\'] img').attr('src');
		// let labelIdToScroll = $( 'a[data-id-anchor=\''+idToScroll+'\']' ).attr('data-label');

		//$('.tool-anchor-indicator-mobile').html(labelIdToScroll.replace('<br>',' '));

		//$('.tool-anchor-indicator-mobile').html('<img src="'+iconIdToScroll+'">' + labelIdToScroll.replace('<br>',' '));

		// dal menu cerca se esiste una voce con id uguale e lo raggiunge
		// inoltre è possibile tornare indietro al menù dalla voce in cui si arriva
		let elmToScroll = jQuery('#tgt-'+idToScroll);
		// let elmPaddingTop = 0;
		// if(!elmToScroll.hasClass('site-block')) {
		// 	elmPaddingTop = parseInt(elmToScroll.parent().parent().parent().css('padding-top'));
		// }
		// elmPaddingTop = 0;
		elmToScroll.focus();
		
		elmToScroll.on('keydown.returnToMenu', function(e) {
            if (e.shiftKey && e.key === 'Tab' && document.activeElement === this) {
                e.preventDefault();
                let menuItem = _this.container.find(`a[data-id-anchor='${idToScroll}']`);
                menuItem.focus();
                elmToScroll.off('keydown.returnToMenu');
            }
        });

		let elmGetH = jQuery('div.sticky-element > nav.modules-nav > #tool-modules-mobile', _this.container);
		let containerHeight = 0;
		if(elmGetH.length) {
			containerHeight = elmGetH.height();
		}

		jQuery(window).scrollTo(elmToScroll, {
			duration: 500,
			offset: {
				//top: -(jQuery('header').height() + containerHeight + elmPaddingTop),
				top: -(jQuery('header').height() + containerHeight + 50),
			},
		});
	}

	attachScrollDetectMouse(){

		//$('body').mousewheel(function(event) {
		$('body').mousewheel(function() {

			clearTimeout(_this.wheeling);
			_this.wheeling = setTimeout(function() {
				//console.log('stop wheeling!');
				_this.wheeling = false;
				//_this.TLMove.reverse();
				_this.currMove = 0;
				_this.wheeling = undefined;


				// reset wheeldelta
				_this.wheeldelta.y = 0;
			}, 250);

			_this.wheeling = true;

			/*let offsetScrollY = event.deltaY*event.deltaFactor;

			 _this.totalMove += offsetScrollY;
			 if(_this.totalMove >= 0)
			 _this.totalMove = 0;*/


			let scrollToTop = $(window).scrollTop();

			//console.log('DELTA Y: ',event.deltaY);
			//console.log('DELTA FACTOR: ',event.deltaFactor);
			//console.log('TOTAL MOVE',_this.totalMove);
			console.log('SCROLL TO TOP',scrollToTop);



		});

	}

	attachSwipeDetect(){

		$('body').swipe( {
			swipe:function(event, direction)
			{
				console.log('DIRECTION SWIPE : ' ,direction);
				console.log('EVENT SWIPE : ' ,event);


				let scrollToTop = $(window).scrollTop();

				console.log('BODY SCROLL : ' ,scrollToTop);

				//console.log("ELEM HOVER",_this.currElemOnHover);

				/*
				 if(_this.verticalOnMobile && windowWidth <= _this.limitMobileWidth){
				 return;
				 }
				 if(windowWidth <= _this.limitMobileWidth){
				 //console.log("SWIPE SINGLE swipe direction : " + currentDirection, "Distance from inital touch: " + distance, "Duration of swipe: " + duration + " Current direction: " + currentDirection );

				 if(direction == "left") {

				 let sectionSwipeToLeftForce = $(_this.slideNavigation.get(window.indexCurrentActiveElementSliderNavigation)).attr("data-swipe-left-to");
				 if(sectionSwipeToLeftForce != undefined)
				 _this.goToSection(sectionSwipeToLeftForce);
				 else
				 _this.goToNextSection();
				 }

				 if(direction == "right") {

				 let sectionSwipeToRightForce = $(_this.slideNavigation.get(window.indexCurrentActiveElementSliderNavigation)).attr("data-swipe-right-to");
				 if(sectionSwipeToRightForce != undefined)
				 _this.goToSection(sectionSwipeToRightForce);
				 else
				 _this.goToPrevSection();
				 }

				 //_this.move(distance,currentDirection);
				 }*/

			},
			threshold:10,
			maxTimeThreshold:5000,
			fingers:'all',
		});
	}



}

export default anchorTool



// WEBPACK FOOTER //
// ./scripts/components/anchorTool.js